module.exports = __webpack_public_path__ + "static/img/Risk250108EN.a12763c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk250108EN.jpg
// module id = Ir5i
// module chunks = 1